import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/capacitor'
import pkgJson from '../package.json'
import * as SentryAngular from '@sentry/angular'

if (environment.production) {
  enableProdMode();
}
Sentry.init(
  {
    dsn: 'https://9974fd4e98ad4d2e909c91dfc4a4859d@o62469.ingest.sentry.io/6170114',
    release: pkgJson.version,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/capacitor/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    dist: 'production',
    enabled: environment.production
  },
  SentryAngular.init
)

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
